var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import Highlighter from '../Highlighter';
import Tooltip from '../Tooltip';
import { EventDuration, LockTag } from '../style';
import { Card, CardBody, SessionTitle, EventName, DateContainer } from './style';
var SessionCard = function (props) {
    var titleRef = useRef(null);
    var title = props.title, eventName = props.eventName, startDateTime = props.startDateTime, isRestricted = props.isRestricted, titleHighlightingInformation = props.titleHighlightingInformation, conferenceNameHighlightingInformation = props.conferenceNameHighlightingInformation;
    var scheduledFor = startDateTime
        ? format(new Date(startDateTime), 'MMM d, yyyy')
        : null;
    return (_jsx(Card, { children: _jsxs(CardBody, { children: [_jsxs("div", { children: [_jsxs(DateContainer, { children: [isRestricted && (_jsx(LockTag, { children: _jsx(FontAwesomeIcon, { icon: faLock, height: 16, width: 16 }) })), _jsx(EventDuration, { children: scheduledFor })] }), _jsx(Tooltip, __assign({ content: title, childRef: titleRef }, { children: _jsx(SessionTitle, __assign({ size: "h5_new" }, { children: _jsx("div", __assign({ ref: titleRef }, { children: _jsx(Highlighter, { value: (titleHighlightingInformation === null || titleHighlightingInformation === void 0 ? void 0 : titleHighlightingInformation.value) || title }) })) })) }))] }), eventName && (_jsxs(EventName, { children: ["At", ' ', _jsx(Highlighter, { value: (conferenceNameHighlightingInformation === null || conferenceNameHighlightingInformation === void 0 ? void 0 : conferenceNameHighlightingInformation.value) || eventName })] }))] }) }));
};
export default SessionCard;
//# sourceMappingURL=index.js.map